import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRoles, fetchCapabilityCatalog, createRole, updateRole, removeRole, ensureSystemRoles } from '../../actions/roleActions';

export default function AdminRoles() {
  const dispatch = useDispatch();
  const { items, capabilities } = useSelector(s => s.roles);
  const [editing, setEditing] = useState(null);          // role _id or 'new'
  const [draft, setDraft] = useState({ name: '', description: '', capabilities: [] });

  useEffect(() => {
    dispatch(fetchRoles());
    dispatch(fetchCapabilityCatalog());
  }, [dispatch]);

  const groups = capabilities.reduce((acc, c) => { (acc[c.group] = acc[c.group] || []).push(c); return acc; }, {});

  const startEdit = (role) => {
    setEditing(role._id);
    setDraft({ name: role.name, description: role.description || '', capabilities: role.capabilities || [] });
  };
  const startNew = () => { setEditing('new'); setDraft({ name: '', description: '', capabilities: [] }); };
  const toggleCap = (key) => {
    setDraft(d => ({ ...d, capabilities: d.capabilities.includes(key) ? d.capabilities.filter(k => k !== key) : [...d.capabilities, key] }));
  };
  const save = async () => {
    if (!draft.name) return;
    if (editing === 'new') {
      const res = await dispatch(createRole(draft));
      if (res.ok) { setEditing(null); }
    } else {
      const res = await dispatch(updateRole(editing, draft));
      if (res.ok) { setEditing(null); }
    }
  };
  const seed = async () => { await dispatch(ensureSystemRoles()); dispatch(fetchRoles()); };

  return (
    <section className="section">
      <div className="section-head">
        <h1>Roles &amp; permissions</h1>
        <div>
          {items.length === 0 && <button className="btn-ghost" type="button" onClick={seed} style={{marginRight:'.6rem'}}>Seed system roles</button>}
          <button className="btn-primary" type="button" onClick={startNew}>New role</button>
        </div>
      </div>

      <div className="card">
        <h2>All roles</h2>
        <table className="data-table">
          <thead><tr><th>Name</th><th>Slug</th><th>Capabilities</th><th>Type</th><th style={{textAlign:'right'}}>Actions</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan="5" className="muted">No roles yet. Hit "Seed system roles" to create the defaults.</td></tr>}
            {items.map(r => (
              <tr key={r._id}>
                <td><strong>{r.name}</strong>{r.description ? <div className="muted" style={{fontSize:'.8rem'}}>{r.description}</div> : null}</td>
                <td><code>{r.slug}</code></td>
                <td>{r.capabilities.length}</td>
                <td>{r.isSystem ? 'Built-in' : 'Custom'}</td>
                <td style={{textAlign:'right'}}>
                  <button className="btn-ghost" style={{marginRight:'.4rem',padding:'.3rem .7rem'}} onClick={() => startEdit(r)} disabled={r.isSystem}>{r.isSystem ? 'View' : 'Edit'}</button>
                  {!r.isSystem && <button onClick={() => confirm(`Delete role ${r.name}?`) && dispatch(removeRole(r._id))} style={{padding:'.3rem .7rem',border:'1.5px solid #f0c4c4',background:'white',color:'#b53b3b',borderRadius:'6px',cursor:'pointer',fontWeight:600,fontSize:'.85rem'}}>Delete</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="card">
          <h2>{editing === 'new' ? 'New role' : 'Edit role'}</h2>
          <div className="auth-form" style={{maxWidth:'620px'}}>
            <label>Name<input value={draft.name} onChange={e => setDraft({...draft, name: e.target.value})} /></label>
            <label>Description<input value={draft.description} onChange={e => setDraft({...draft, description: e.target.value})} /></label>
          </div>
          <h3 style={{marginTop:'1.2rem'}}>Capabilities</h3>
          {Object.keys(groups).map(g => (
            <div key={g} style={{marginBottom:'1rem'}}>
              <h4 style={{margin:'.4rem 0',fontSize:'.85rem',letterSpacing:'.1em',textTransform:'uppercase',color:'#6c7d92'}}>{g}</h4>
              <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:'.4rem'}}>
                {groups[g].map(c => (
                  <label key={c.key} style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.92rem',fontWeight:400,color:'#1a2230'}}>
                    <input type="checkbox" checked={draft.capabilities.includes(c.key)} onChange={() => toggleCap(c.key)} />
                    {c.label} <code style={{fontSize:'.75rem',color:'#6c7d92'}}>{c.key}</code>
                  </label>
                ))}
              </div>
            </div>
          ))}
          <div style={{marginTop:'1rem'}}>
            <button className="btn-primary" type="button" onClick={save}>Save</button>
            <button className="btn-ghost" type="button" onClick={() => setEditing(null)} style={{marginLeft:'.6rem'}}>Cancel</button>
          </div>
        </div>
      )}
    </section>
  );
}
